import { render, staticRenderFns } from "./FaqSearch.vue?vue&type=template&id=bbadcaf2&scoped=true&"
import script from "./FaqSearch.vue?vue&type=script&lang=js&"
export * from "./FaqSearch.vue?vue&type=script&lang=js&"
import style0 from "./FaqSearch.vue?vue&type=style&index=0&id=bbadcaf2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbadcaf2",
  null
  
)

export default component.exports